import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Skeleton from '@mui/material/Skeleton';
import Slide from '@mui/material/Slide';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';

export default function ClientAccount(props) {

    const [client, setClient] = React.useState([]);
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [IsEdittingAccount, setIsEdittingAccount] = React.useState(false);

    
    const [IsEdittingFinancials, setIsEdittingFinacials] = React.useState(false);

    // for editting fields:
    const [customerEmail, setcustomerEmail]= React.useState('');
    const [customerName, setcustomerName]= React.useState('');
    const [customerLastname, setcustomerLastname]= React.useState('');
    const [customerPhoneNum, setcustomerPhoneNum]= React.useState('');
    const [customerAddress_Street, setcustomerAddress_Street]= React.useState('');
    const [customerAddress_Apt_Suit_Other, setcustomerAddress_Apt_Suit_Other]= React.useState('');
    const [customerAddress_City, setcustomerAddress_City]= React.useState('');
    const [customerAddress_State, setcustomerAddress_State]= React.useState('');
    const [customerAddress_Zipcode, setcustomerAddress_Zipcode]= React.useState('');
    const [latitude, setlatitude]= React.useState('');
    const [longitude, setlongitude]= React.useState('');
    const [payeeName, setpayeeName]= React.useState('');
    const [memo, setmemo]= React.useState('');


    const [formValidation, setFormValidation] = React.useState({
        isValid: false,
        errors: []
    });

    React.useEffect(() => {
        loadData(); // only called once
    }, []);

    function loadData() {
        setIsFetching(true);

        TokenService.customerPost('', 'MyInfo')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);

                    setClient(JSON.parse(jsonData.Client));

                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function normalizePhoneNumber(value, previousValue) {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        //if (!previousValue)// || value.length > previousValue.length)
        {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    function setPhoneNumberChanged(val) {
        let phone = normalizePhoneNumber(val);
        setcustomerPhoneNum(phone);
    }

    function toggleIsEdittingAccount(editting) {
        if (editting) {
            setcustomerEmail(client.CustomerEmail);
            setcustomerName(client.CustomerName);
            setcustomerLastname(client.CustomerLastname);
            setcustomerPhoneNum(normalizePhoneNumber(client.CustomerPhoneNum));
            setcustomerAddress_Street(client.CustomerAddress_Street);
            setcustomerAddress_Apt_Suit_Other(client.CustomerAddress_Apt_Suit_Other);
            setcustomerAddress_City(client.CustomerAddress_City);
            setcustomerAddress_State(client.CustomerAddress_State);
            setcustomerAddress_Zipcode(client.CustomerAddress_Zipcode);
           
            setFormValidation({
                isValid: true,
                errors: []
            });

        }
        setIsEdittingAccount(editting);
    }

    function toggleIsEdittingFinancials(editting) {
     

        if (editting) {
            setpayeeName(client.PayeeName);
            setmemo(client.Memo);
        }
        setIsEdittingFinacials(editting);
    }

    function handleSaveClient() {
        let isValid = true;

        let errors = [];
       
        if (customerName.trim() == '') {
            isValid = false;
            errors["customerName"] = "First name is required";
        }

        if (customerLastname.trim() == '') {
            isValid = false;
            errors["customerLastname"] = "Last name is required";
        }

        if (customerPhoneNum.trim() == '') {
            isValid = false;
            errors["customerPhoneNum"] = "Phone Number is required";
        }

        if (customerAddress_Street.trim() == '') {
            isValid = false;
            errors["customerAddress_Street"] = "Street is required";
        }

        if (customerAddress_City.trim() == '') {
            isValid = false;
            errors["customerAddress_City"] = "City is required";
        }

        if (customerAddress_Zipcode.trim() == '') {
            isValid = false;
            errors["customerAddress_Zipcode"] = "Zip is required";
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        if (isValid) {
            setIsFetching(true);
            
            let postData = {
                client: JSON.stringify({
                    CustomerName: customerName,
                    CustomerLastname: customerLastname,
                    CustomerPhoneNum: customerPhoneNum,
                    CustomerAddress_Street: customerAddress_Street,
                    CustomerAddress_Apt_Suit_Other: customerAddress_Apt_Suit_Other,
                    CustomerAddress_City: customerAddress_City,
                    CustomerAddress_Zipcode: customerAddress_Zipcode
                })
            }
       
            TokenService.customerPost(postData, 'MyInfo_Update')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);

                        setClient(JSON.parse(jsonData.Client));

                        setIsFetching(false);
                        setIsEdittingAccount(false);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
    }

    function handleSaveFinancials() {
        alert('Save Financials not yet implemented');
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function handleZipcodeChanged(e) {
        let value = e.target.value.replace(/\D/g, "");
        setcustomerAddress_Zipcode(value);
    }

    function buildClient() {
        return (<Stack spacing={1}>
            <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>Contact Info</div>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <AccountCircleIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                {IsEdittingAccount ?
                    <div style={{ marginLeft: '10px' }}>
                        <div>
                            <TextField error={formValidation.errors['customerName'] !== undefined} label="First Name" onChange={(e) => setcustomerName(e.target.value)} value={customerName} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerName'] !== undefined ? formValidation.errors['customerName'] : ''}</div>
                        </div>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['customerLastname'] !== undefined} label="Last Name" onChange={(e) => setcustomerLastname(e.target.value)} value={customerLastname} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerLastname'] !== undefined ? formValidation.errors['customerLastname'] : ''}</div>
                        </div>
                    </div>
                    :
                    <div style={{ marginRight: 'auto', marginLeft: 'auto', fontWeight: 'bold', fontSize: '14pt', alignSelf: 'center' }}>{client.CustomerName} {client.CustomerLastname}</div>
                }
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <PhoneIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf: 'center' }} />

                {IsEdittingAccount ?
                    <div style={{ marginLeft: '10px' }}>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['customerPhoneNum'] !== undefined} label="Phone Number" onChange={(e) => setPhoneNumberChanged(e.target.value)} value={customerPhoneNum} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerPhoneNum'] !== undefined ? formValidation.errors['customerPhoneNum'] : ''}</div>
                        </div>
                    </div>
                    :
                    <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerPhoneNum}</div>

                }
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <EmailIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf: 'center' }} />
                <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerEmail}</div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {client.LocationType == 'Residence' ? 
                    <HomeIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                    :
                    <BusinessIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                }
                
                {IsEdittingAccount ?
                    <div style={{ marginLeft: '10px' }}>
                        <div>
                            <TextField error={formValidation.errors['customerAddress_Street'] !== undefined} label="Street" onChange={(e) => setcustomerAddress_Street(e.target.value)} value={customerAddress_Street} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_Street'] !== undefined ? formValidation.errors['customerAddress_Street'] : ''}</div>
                        </div>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['customerAddress_Apt_Suit_Other'] !== undefined} label="Apt/Suite" onChange={(e) => setcustomerAddress_Apt_Suit_Other(e.target.value)} value={customerAddress_Apt_Suit_Other} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_Apt_Suit_Other'] !== undefined ? formValidation.errors['customerAddress_Apt_Suit_Other'] : ''}</div>
                        </div>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['customerAddress_City'] !== undefined} label="City" onChange={(e) => setcustomerAddress_City(e.target.value)} value={customerAddress_City} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_City'] !== undefined ? formValidation.errors['customerAddress_City'] : ''}</div>
                        </div>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['customerAddress_State'] !== undefined} disabled={true} label="State" value={customerAddress_State} variant="outlined" style={{ maxWidth: '270px' }} />
                        </div>
                        <div style={{ marginTop: '7px' }}>
                            <TextField error={formValidation.errors['customerAddress_Zipcode'] !== undefined} label="Zip" onChange={(e) => handleZipcodeChanged(e)} value={customerAddress_Zipcode} variant="outlined" style={{ maxWidth: '270px' }} inputProps={{ maxLength:5, inputMode: 'numeric', pattern: '[0-9]*' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_Zipcode'] !== undefined ? formValidation.errors['customerAddress_Zipcode'] : ''}</div>
                        </div>
                    </div>
                    :
                    <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>
                        <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerAddress_Street} {client.CustomerAddress_Apt_Suit_Other}</div>
                        <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerAddress_City}, {client.CustomerAddress_State} {client.CustomerAddress_Zipcode}</div>
                    </div>
                }
            </div>

            <div>

                {IsEdittingAccount ?
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                        <Fab onClick={() => toggleIsEdittingAccount(false)}>
                            <DoDisturbIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30 }} />
                        </Fab>
                        <Fab onClick={handleSaveClient}>
                            <SaveIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} ></SaveIcon>
                        </Fab>
                    </div>
                    :
                    <Fab onClick={() => toggleIsEdittingAccount(true)}>
                        <EditIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} />
                    </Fab>
                }


            </div>

            </Stack>)
    }

    function buildFinancials() {
        return <Stack spacing={1}>
            <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color:'var(--sipzee-yellow)' }}>Payment Info</div>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <DriveFileRenameOutlineIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                {IsEdittingFinancials ?
                    <div style={{ marginLeft: '10px' }}>
                        <div>
                            <TextField error={formValidation.errors['customerName'] !== undefined} label="Check Payee Name" onChange={(e) => setpayeeName(e.target.value)} value={payeeName} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['payeeName'] !== undefined ? formValidation.errors['payeeName'] : ''}</div>
                        </div>
                    </div>
                    :
                    <div>
                        <div style={{ marginLeft: '5px' }}>Check Payee:</div>
                        <div style={{ marginLeft: '5px' }}>{client.PayeeName === '' ? '[Blank]' : client.PayeeName}</div>
                    </div>
                }
              
            </div>
            <div style={{ fontStyle: 'italic', fontSize:'10pt' }}>Optional: Leave Blank unless you need it different from your contact name (ie, your business name)</div>

            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <StickyNote2Icon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                {IsEdittingFinancials ?
                    <div style={{ marginLeft: '10px' }}>
                        <div>
                            <TextField error={formValidation.errors['memo'] !== undefined} label="Check Memo Line" onChange={(e) => setmemo(e.target.value)} value={memo} variant="outlined" style={{ maxWidth: '270px' }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['memo'] !== undefined ? formValidation.errors['memo'] : ''}</div>
                        </div>
                    </div>
                    :
                    <div>
                        <div style={{marginLeft: '5px' }}>Check Memo:</div>
                        <div style={{ marginLeft: '5px' }}>{client.Memo === '' ? '[Blank]' : client.Memo}</div>
                    </div>
                }

            </div>
            <div style={{ fontStyle: 'italic', fontSize: '10pt' }}>Optional: Leave Blank unless you need something written on the Memo Line of your checks</div>

            <div>

                {IsEdittingFinancials ?
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                        <Fab onClick={() => toggleIsEdittingFinancials(false)}>
                            <DoDisturbIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30 }} />
                        </Fab>
                        <Fab onClick={handleSaveFinancials}>
                            <SaveIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} ></SaveIcon>
                        </Fab>
                    </div>
                    :
                    <Fab onClick={() => toggleIsEdittingFinancials(true)}>
                        <EditIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} />
                    </Fab>
                }


            </div>
        </Stack>
    }

    function handleEmailPreferencesChanged(value) {
       
        
       // setIsFetching(true);

        let postData = {
            client: JSON.stringify({
                EmailReminders: value
            })
        }
        let tempClient = cloneDeep(client);
        tempClient.EmailReminders = value;
        setClient(tempClient);

        TokenService.customerPost(postData, 'MyInfo_Update')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);

                    setClient(JSON.parse(jsonData.Client));

                   // setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
       
    }

    function buildScheduleReminders() {
        return <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>
                <span>Email Reminders</span>
                <InsertInvitationIcon sx={{ color: 'var(--sipzee-green)' }} />
            </div>
            <div style={{textAlign:'left'} }>
                For business customers, we can send you an email reminder to check if you are ready for another pickup.
            </div>
            
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                >
                    <FormControlLabel value="None" control={<Radio value="None" checked={client.EmailReminders == '' || client.EmailReminders == 'None'} onChange={(e) => handleEmailPreferencesChanged(e.target.value)} />} label="None" />
                    <FormControlLabel value="Monthly" control={<Radio value="Monthly" checked={client.EmailReminders == 'Monthly'} onChange={(e) => handleEmailPreferencesChanged(e.target.value)} />} label="1st of the month" />
                    <FormControlLabel value="Bimonthly" control={<Radio value="Bimonthly" checked={client.EmailReminders == 'Bimonthly'} onChange={(e) => handleEmailPreferencesChanged(e.target.value)} />} label="1st and 15th of the month" />
                    <FormControlLabel value="Weekly" control={<Radio value="Weekly" checked={client.EmailReminders == 'Weekly'} onChange={(e) => handleEmailPreferencesChanged(e.target.value)} />} label="Weekly" />
                </RadioGroup>
            </FormControl>
        </div>
    }

    return (<div style={{ backgroundColor:"rgb(245, 245, 245)", paddingBottom:'50px', display:'flex', justifyContent:'center', flexDirection:'column'} }>
        <Card style={{maxWidth:'330px', width:'330px', marginTop:'25px', alignSelf:'center'} }>
            <CardContent>
        {isFetching ? buildSkeleton() :
            buildClient()
                }
            </CardContent>


        </Card>

        {client.LocationType == 'Residence_dontfind' ? null :
            
        <Card style={{ maxWidth: '330px', width: '330px', marginTop: '25px', alignSelf: 'center' }}>
            <CardContent>
                {isFetching ? buildSkeleton() :
                    buildScheduleReminders()
                }
            </CardContent>
            </Card>
        }
    </div>)
}